import React, { useContext } from 'react'
import { Modal } from 'react-bootstrap'
import { PlanesContext } from '../DOPlanes';

export const ModalInfo = ({ showModal = false, setShowModal = () => { } }) => {
    const {
        info = []
    } = useContext(PlanesContext);
    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName={'modal-content-rcpa'}
        >
            <Modal.Header className="p-5" closeButton></Modal.Header>
            <Modal.Body>
                <div className="col-12 p-0">
                    {info.map(item => {
                        return <div key={item?.titulo} className='row col-12 d-flex justify-content-center'>
                            <div className='col-5 text-left'>
                                <b>{item?.titulo}</b>
                            </div>
                            <div className='col-5 text-right align-self-center'>
                                {item?.valor}
                            </div>
                            <hr className='col-12'/>
                        </div>
                    }
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer className="row d-flex justify-content-center">
                <button className="btn btn-primary" onClick={() => { setShowModal(false) }}>
                    Cerrar
                </button>
            </Modal.Footer>
        </Modal>
    )
}
